module.exports = __webpack_public_path__ + "static/experiments-cropped-163afa271983a2136db3e35f98dcf44f.mp4";